var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 3.79086 4.79086 2 7 2C9.20914 2 11 3.79086 11 6C11 8.20914 9.20914 10 7 10C4.79086 10 3 8.20914 3 6ZM7 0C3.68629 0 1 2.68629 1 6C1 8.39304 2.40096 10.4589 4.42745 11.4221C1.90175 12.2787 0 14.3657 0 17C0 17.5523 0.447715 18 1 18C1.55228 18 2 17.5523 2 17C2 14.9538 4.06012 13 7 13C9.93988 13 12 14.9538 12 17C12 17.5523 12.4477 18 13 18C13.5523 18 14 17.5523 14 17C14 14.3657 12.0982 12.2787 9.57255 11.4221C11.599 10.4589 13 8.39304 13 6C13 2.68629 10.3137 0 7 0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.9ead0dce89c792db2a60723fe3075746.svg";
export { ForwardRef as ReactComponent };